import { FormEvent, useState } from "react";

import { updateTeam } from "./api";
import type { Region, TeamDetail } from "./types";

export function TeamSettings({
  team,
  regions,
  onSaved,
  onCancel,
}: {
  team: TeamDetail;
  regions: Region[];
  onSaved: () => Promise<void>;
  onCancel: () => void;
}) {
  const [sending, setSending] = useState(false);
  const [failed, setFailed] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSending(true);
    setFailed(false);
    const fields = new FormData(event.currentTarget);
    try {
      await updateTeam(team.id, {
        name: String(fields.get("name")),
        active: fields.get("active") === "on",
        defaultRegionId: nullable(fields.get("defaultRegionId")),
        notes: nullable(fields.get("notes")),
      });
      await onSaved();
    } catch {
      setFailed(true);
      setSending(false);
    }
  }

  return (
    <form className="record-form team-inline-form" onSubmit={submit}>
      <div className="form-grid">
        <label>
          Team name
          <input name="name" defaultValue={team.name} required />
        </label>
        <label>
          Default region
          <select name="defaultRegionId" defaultValue={team.defaultRegionId ?? ""}>
            <option value="">No default region</option>
            {regions.map((region) => (
              <option key={region.id} value={region.id}>
                {region.name}
              </option>
            ))}
          </select>
        </label>
        <label className="wide-field">
          Notes
          <textarea name="notes" defaultValue={team.notes ?? ""} rows={3} />
        </label>
        <label className="toggle-field workforce-toggle">
          <input type="checkbox" name="active" defaultChecked={team.active} /> Active team
        </label>
      </div>
      {failed ? <p className="form-error">We couldn’t save this team.</p> : null}
      <div className="form-actions">
        <button type="button" className="secondary-button" onClick={onCancel}>
          Cancel
        </button>
        <button className="primary-button compact-action" disabled={sending}>
          Save
        </button>
      </div>
    </form>
  );
}

function nullable(value: FormDataEntryValue | null) {
  const text = String(value ?? "").trim();
  return text || null;
}
